import { type H3Event, getRequestHeaders } from 'h3'

import type { Market } from '@backmarket/http-api'
import { getRequestExperiments } from '@backmarket/nuxt-module-experiments/getRequestExperiments'

import { getMarkets } from '../app/utils/getMarkets'

import { getRequestCountryCode } from './getRequestCountryCode'

/** Get market from H3 event. */
export function getRequestMarket(event: H3Event): Market {
  const headers = getRequestHeaders(event)
  const experiments = getRequestExperiments(headers)
  const enableEsUsContent =
    experiments['experiment.enableEsUsContent'] !== 'disabled'

  const markets = getMarkets(enableEsUsContent)

  const countryCode = getRequestCountryCode(event)

  return markets[countryCode]
}
